import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** three dots, more. Decorative line icon; always pair with a visible text label. */
export function MoreIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <circle cx="5.5" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="18.5" cy="12" r="1.2" fill="currentColor" stroke="none" />
    </IconSvg>
  )
}
